class DrReviewLink extends HTMLElement {
  connectedCallback() {
    this.observer?.disconnect();
    const main = document.querySelector('#MainContent');
    if (!main) return;
    this.update = () => {
      const title = main.querySelector('h1');
      const widget = main.querySelector('#judgeme_product_reviews');
      const badge = main.querySelector('.jdgm-prev-badge[data-number-of-reviews]');
      const raw = widget?.getAttribute('data-number-of-reviews') || badge?.getAttribute('data-number-of-reviews') || '';
      const count = /^\d+$/.test(raw) ? Number(raw) : 0;
      let link = main.querySelector('[data-dr-review-jump]');
      if (!title || !widget || count <= 0) { link?.remove(); return; }
      if (!link) {
        link = document.createElement('a');
        link.dataset.drReviewJump = '';
        link.className = 'dr-review-jump';
        link.href = '#judgeme_product_reviews';
        title.insertAdjacentElement('afterend', link);
      }
      const label = this.dataset.label.replace('__COUNT__', String(count));
      if (link.textContent !== label) link.textContent = label;
    };
    this.observer = new MutationObserver(this.update);
    this.observer.observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-number-of-reviews'] });
    this.update();
  }
  disconnectedCallback() { this.observer?.disconnect(); }
}
if (!customElements.get('dr-review-link')) customElements.define('dr-review-link', DrReviewLink);
